module.exports = __webpack_public_path__ + "img/CALL_TO_ACTION.9ee7c9b5.svg";